require("regenerator-runtime/runtime");
const Logger = require("../Logger");

const clearCache = async (playerIntegration) => {
  Logger.viewerDebug("Requested clear cache");

  const cacheKeys = await caches.keys();

  return Promise.all(cacheKeys.map((key) => { return caches.delete(key); }))
    .then(() => {
      Logger.viewerDebug("Cache cleared successfully");
      playerIntegration.flushLocalStorageToDisk();
      setTimeout(() => {
        playerIntegration.requestRestart();
      }, 2000);
    })
    .catch((error) => {
      Logger.viewerError("E999999999", "Cache clearing failed", error.message);
    });
};

const RemoteCacheController = {
  clearCache
};

module.exports = RemoteCacheController;
